export interface MailCredential {
  id: string;
  description: string;
  expiresAt?: string;
}

export interface MailSettings {
  address: string;
  imapHost: string;
  imapPort: number;
  smtpHost: string;
  smtpPort: number;
}

export interface MailCredentialsResponse {
  settings: MailSettings;
  credentials: MailCredential[];
}

export interface CreatedMailCredential extends MailCredential {
  secret: string;
}

async function parse<T>(response: Response): Promise<T> {
  if (!response.ok) {
    const body = await response.json().catch(() => ({ error: `Request failed with status ${response.status}` }));
    throw new Error(body.error || `Request failed with status ${response.status}`);
  }
  return response.status === 204 ? (undefined as T) : response.json();
}

export async function fetchMailCredentials(): Promise<MailCredentialsResponse> {
  return parse(await fetch('/api/mail-credentials', { credentials: 'same-origin', cache: 'no-store' }));
}

export async function createMailCredential(description: string): Promise<CreatedMailCredential> {
  return parse(await fetch('/api/mail-credentials', {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ description }),
  }));
}

export async function revokeMailCredential(id: string): Promise<void> {
  return parse(await fetch(`/api/mail-credentials/${encodeURIComponent(id)}`, {
    method: 'DELETE',
    credentials: 'same-origin',
  }));
}
